import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background p-4 sm:p-6 md:p-8">
      <div className="mx-auto w-full max-w-4xl rounded-xl bg-white p-5 shadow-card sm:p-7 md:p-10">
        <div className="mb-6 flex items-center justify-between gap-3">
          <h1 className="text-2xl font-bold text-text sm:text-3xl">Terms &amp; Conditions</h1>
          <button
            type="button"
            onClick={() => navigate('/')}
            className="text-primary underline underline-offset-4 hover:text-hover"
          >
            Back to Home
          </button>
        </div>

        <p className="mb-6 text-secondary-text">Last Updated: 24-11-2025</p>

        <div className="space-y-6 leading-relaxed text-secondary-text">
          <section>
            <h2 className="mb-2 text-lg font-semibold text-text sm:text-xl">1. Acceptance of Terms</h2>
            <p>
              These Terms &amp; Conditions govern access to and use of PutPens. By creating an
              account, accessing the platform, or using any PutPens service, you agree to these
              terms on behalf of yourself and, where applicable, the company or organization you
              represent.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-text sm:text-xl">2. Platform Services</h2>
            <p>
              PutPens provides construction project management tools that may include company
              workspaces, admin, manager, and team member accounts, project and task workflows,
              file and attachment handling, notifications, support channels, and subscription-based
              access to paid features.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-text sm:text-xl">3. Accounts and Company Responsibility</h2>
            <p>
              Company accounts are responsible for the activity of their authorized users.
              Administrators may invite, manage, suspend, or remove admin, manager, and team member
              accounts. You must provide accurate information, maintain the confidentiality of login
              credentials, and promptly notify PutPens of any suspected unauthorized access.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-text sm:text-xl">4. Tasks, Projects, and Attachments</h2>
            <p>
              Users may create projects, assign tasks, upload files, and share attachments as part
              of normal platform use. You are responsible for ensuring that the content you submit
              is lawful, accurate, relevant to your work, and that you have the necessary rights to
              upload, store, and share it through PutPens.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-text sm:text-xl">5. Notifications and Communications</h2>
            <p>
              PutPens may send in-app, browser, email, or other service-related notifications for
              task assignments, project updates, approvals, reminders, billing events, and support
              communications. You are responsible for maintaining valid contact information and
              device settings needed to receive important service notices.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-text sm:text-xl">6. Subscriptions and Payments</h2>
            <p>
              Some PutPens features may require a paid subscription. Fees, billing cycles, renewal
              terms, and payment obligations are governed by the selected plan or applicable order.
              Failure to pay may result in suspension, downgrade, or loss of access to paid
              features, subject to any legally required notice periods.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-text sm:text-xl">7. Support Requests</h2>
            <p>
              PutPens may provide customer support for account, billing, technical, and product
              issues. When submitting support requests, you agree to provide accurate details and to
              avoid sharing sensitive information that is not necessary for troubleshooting.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-text sm:text-xl">8. Acceptable Use</h2>
            <p>
              You may not use PutPens to violate laws, infringe intellectual property rights,
              distribute malware, interfere with the platform, gain unauthorized access, abuse
              notifications, upload harmful or deceptive content, or use the service in a way that
              disrupts operations for other users or companies.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-text sm:text-xl">9. Security</h2>
            <p>
              PutPens applies reasonable administrative, organizational, and technical safeguards to
              protect platform data and company workspaces. You are also responsible for using
              secure passwords, limiting account access to authorized users, and following your
              organization&apos;s internal security practices.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-text sm:text-xl">10. Intellectual Property and Service Ownership</h2>
            <p>
              PutPens and its related branding, software, interface, and service materials remain
              the property of their respective owners. Except for the limited right to use the
              platform under these terms, no ownership rights are transferred to you.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-text sm:text-xl">11. Suspension and Termination</h2>
            <p>
              PutPens may suspend or terminate access where necessary to protect the platform,
              investigate misuse, enforce these terms, respond to legal obligations, or address
              non-payment. Company administrators may also remove user access within their
              organization.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-text sm:text-xl">12. Changes to These Terms</h2>
            <p>
              We may update these Terms &amp; Conditions from time to time. The latest version will
              be posted on this page with the updated date shown above. Continued use of PutPens
              after changes take effect means you accept the revised terms.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-text sm:text-xl">13. Contact</h2>
            <p>
              For questions about these Terms &amp; Conditions, contact:{' '}
              <span className="font-medium">support@putpens.com</span> or visit{' '}
              <span className="font-medium">putpens.com</span>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
